import { entityConfig as weakEntityConfig } from '@/lib/realtime/weak/entityConfig';
import {
  batchHardCodedHandlers,
  hardCodedHandlers,
} from '@/lib/store/otherEntities';
import { SocketService } from '@/plugins/socket-service/SocketService';
import {
  SocketServiceEventType,
  WebsocketControlEvent,
} from '@/plugins/socket-service/socketTypes';
import { Store } from 'vuex';

export const initialiseWebsocket = (
  store: Store<any>,
  socket: SocketService,
) => {
  socket.init(store);

  // Register all our entity handlers
  Object.keys(hardCodedHandlers).forEach((key) => {
    socket.registerHandler(key, `hardCoded-${key}`, hardCodedHandlers[key]);
  });

  Object.keys(batchHardCodedHandlers).forEach((key) => {
    socket.registerBatchHandler(
      key,
      `batch-hardCoded-${key}`,
      batchHardCodedHandlers[key],
    );
  });

  socket.addEventListener(SocketServiceEventType.CONTROL, ({ event }) => {
    if (event === WebsocketControlEvent.NewDeployment) {
      store.dispatch('reloadRequired', true);
    } else if (event === WebsocketControlEvent.ClientAuthenticationSuccessful) {
      socket.subscribeToChannels([
        ...socket.getChannels(),
        ...Array.from(
          new Set([
            ...Object.keys(weakEntityConfig).flatMap((key) => [
              key,
              // Some entityConfig relations don't have their own config so we also need to register them
              ...(weakEntityConfig[key].relations
                ? weakEntityConfig[key].relations
                : []),
            ]),
          ]),
        ),
      ]);
    }
  });
};
